<template>
  <div class="content" v-if="distribution._id">
    <div class="page-inner">
      <div class="page-header">
        <h4 class="page-title">{{ $t('distribution_details') }}</h4>
        <ul class="breadcrumbs">
          <li class="nav-home">
            <router-link to="/dashboard">
              <i class="flaticon-home"></i>
            </router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <router-link to="/distributions">{{ $t('section_distribution') }}</router-link>
          </li>
          <li class="separator">
            <i class="flaticon-right-arrow"></i>
          </li>
          <li class="nav-item">
            <a href="javascript:void(0)">{{ distribution.title }}</a>
          </li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card card-space">
            <div class="card-header clearfix">
              <div class="pull-left">
                <h4 class="card-title">{{ distribution.title }}</h4>
                <h4 class="card-subtitle">{{ distribution.artist.name }}</h4>
              </div>
              <div v-if="!distribution.inactive">
                <div class="pull-right text-right">
                  <div class="pull-right mt-2" v-if="((distribution.status === 3) && user.subscription)">
                    <button @click="showTakedownModal(distribution)" class="btn btn-sm">
                      <span class="fa fa-trash mr-1"></span> {{ $t('takedown_request') }}
                    </button>
                  </div>
                  <div class="pull-right mt-2" v-if="((distribution.status === 3) && !user.subscription && !this.hideTakeDownButton)">
                    <button @click="showTakedownModal(distribution)" class="btn btn-sm">
                      <span class="fa fa-trash mr-1"></span> {{ $t('takedown_request') }}
                    </button>
                  </div>
                   <div class="pull-right mt-2" v-if="((distribution.status === 3) && !user.subscription && this.hideTakeDownButton)">
                    <button @click="upgradeToPro()" class="btn btn-sm">
                      <span class="fa fa-trash mr-1"></span> {{ $t('takedown_request') }}
                    </button>
                  </div>
                  <div v-if="(distribution.status === 2 || distribution.status === 3) && distribution.f_state === 'DELIVERED'">
                    <button
                      v-if="user.subscription"
                      class="btn btn-sm mt-2"
                      @click="openFormInNewTab">
                      {{ $t('request_metadata_changes') }}
                    </button>
                    <button
                      v-else
                      class="btn btn-sm mt-2"
                      @click="showExtraFeaturesModal()">
                      {{ $t('request_metadata_changes') }}
                    </button>
                  </div>
                  <div v-else>
                    <button
                      class="btn btn-sm btn-warning mt-2"
                      @click="user.subscription ? showWarningDataChange() : showExtraFeaturesModal()">
                      {{ $t('request_metadata_changes') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-md-3">
                  <!-- <router-link to="/tools/promo-videos" class="btn btn-primary btn-block btn-promo">
                    Promo Videos
                    <span class="badge badge-danger new">New</span>
                  </router-link> -->
                  <div class="nav flex-column nav-pills nav-secondary nav-pills-no-bd nav-pills-icons" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                    <router-link class="nav-link" :class="{ active: tab === 'details' }" :to="`/distributions/${$route.params.id}/details`">
                      <i class="flaticon-box-1"></i>
                      {{ $t('about_distribution') }}
                    </router-link>
                    <router-link class="nav-link" :class="{ active: tab === 'links' }" :to="`/distributions/${$route.params.id}/links`">
                      <i class="flaticon-share"></i>
                      {{ $t('store_links_description') }}
                    </router-link>
                    <router-link class="nav-link" :class="{ active: tab === 'publishedSongs' }" :to="`/distributions/${$route.params.id}/published-songs`">
                      <i class="flaticon-music-player"></i>
                      {{ $t('songs') }}
                    </router-link>
                    <router-link class="nav-link" :class="{ active: tab === 'publishedStores' }" :to="`/distributions/${$route.params.id}/published-stores`">
                      <i class="flaticon-play-button-1"></i>
                      {{ $t('stores') }}
                    </router-link>
                    <router-link class="nav-link" :class="{ active: tab === 'banners' }" :to="`/distributions/${$route.params.id}/banners`">
                      <i class="flaticon-box-1"></i>
                      {{ $t('banners') }}
                    </router-link>
                    <router-link class="nav-link" :class="{ active: tab === 'comments' }" :to="`/distributions/${$route.params.id}/comments`">
                      <i class="flaticon-box-1"></i>
                      {{ $t('comments') }}
                    </router-link>
                  </div>
                </div>
                <div class="col-12 col-md-9 details">
                  <div class="tab-content">
                    <div class="tab-pane" :class="{ 'active show': tab === 'publishedSongs' }">
                      <div class="accordion accordion-secondary" v-for="song in distribution.songs" v-bind:key="song.name">
                        <div class="card mb-3">
                          <div class="card-header">
                            <div class="span-icon">
                              <div class="flaticon-music-player"></div>
                            </div>
                            {{ song.title }}
                          </div>
                          <div class="card-body">
                            <div>
                              <b>{{ $t('main_genre') }}</b>
                              <br />
                              {{ song.main_genre }}
                            </div>
                            <div class="mt-3">
                              <b>{{ $t('style') }}</b>
                              <br />
                              {{ song.style }}
                            </div>
                            <div class="mt-3" v-if="song.isrc">
                              <b>ISRC</b>
                              <br />
                              {{ song.isrc }}
                            </div>
                            <div class="mt-3" v-if="song.featuring && song.featuring.length">
                              <b>{{ $t('featured_artists') }}</b>
                              <br />
                              <div v-for="(featuring, featuringIndex) in song.featuring" v-bind:key="`featuring_${featuringIndex}`">
                                {{ featuring.name }} {{(featuring.primaryArtist) ? '(' + $t('primary_artist') + ')' : ''}}
                              </div>
                            </div>
                            <div class="mt-3" v-if="song.contributors && song.contributors.data && song.contributors.data.length">
                              <b>{{ $t('contribuitors') }}</b>
                              <br />
                              <div v-for="(contributor, contributorIndex) in song.contributors.data" v-bind:key="`contributor_${contributorIndex}`">
                                {{ contributor.name }} ({{ contributor.role }})
                              </div>
                            </div>
                            <div class="mt-3" v-if="user.allow_downloads">
                              <b>Audio</b>
                              <br />
                              <a :href="song.file_url" download target="_blank">
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" :class="{ 'active show': tab === 'details' }">
                      <!-- <div class="text-center mb-2 mt-2" v-if="!user.subscription">
                        <ins class="adsbygoogle"
                            style="display:block"
                            data-ad-client="ca-pub-8326584585992829"
                            data-ad-slot="8454890613"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                      </div> -->

                      <div class="accordion accordion-secondary">
                        <div class="alert alert-info mt-1" v-if="user.subscription && distribution && distribution.status < 3">
                          <div>{{ $t('boost_by_sharing_presave') }} </div>
                          <div class="mt-1">
                            <span class="badge badge-light" v-if="!user.subscription">{{ $t('pro_only_enabled') }}</span>
                            <a v-if="user.subscription" :href="`https://indiefy.net/release/${distribution.key}`" target="_blank">https://indiefy.net/release/{{distribution.key}}</a>
                          </div>
                        </div>

                        <div class="card">
                          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne">
                            <div class="card-body p-4">
                              <div class="row">
                                <div class="col-6">
                                  <div>
                                    <b>{{ $t('status') }}</b>
                                    <br />
                                    <div
                                      class="badge mt-1"
                                      :class="{ 'badge-info': distribution.status === 2, 'badge-default': distribution.status === 0 && !distribution.reopening_reason, 'badge-warning': distribution.status === 0 && distribution.reopening_reason, 'badge-success': distribution.status === 3, 'badge-danger': contains([6, 5, 4], distribution.status), 'badge-primary': distribution.status === 1 }">
                                      {{ getStatus() }}
                                    </div>
                                  </div>
                                  <div class="mt-3" v-if="distribution.upc">
                                    <b>UPC</b>
                                    <br />
                                    {{ distribution.upc }}
                                  </div>
                                  <div class="mt-3">
                                    <b>{{ $t('release_date') }}</b>
                                    <br />
                                    {{ formattedDate }}
                                  </div>
                                  <div class="mt3" v-if="distribution.status === 5">
                                    <br />
                                    <button type="button" @click="cancelTakedown(distribution._id)" class="btn btn-primary">
                                      <span>{{ $t('cancel_takedown_request') }}</span>
                                    </button>
                                  </div>
                                </div>
                                <div class="col-6">
                                  <b>{{ $t('cover_image') }}</b>
                                  <br />
                                  <a :href="distribution.cover_image" target="_blank">
                                    <img
                                      :src="distribution.cover_image_small || distribution.cover_image_medium || distribution.cover_image"
                                      alt
                                      width="200"
                                      class="img-thumbnail mt-1 cover-img"
                                    />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" :class="{ 'active show': tab === 'links' }" ref="linksTab">
                      <!-- <div class="text-center mb-2 mt-2" v-if="!user.subscription">
                        <ins class="adsbygoogle"
                            style="display:block"
                            data-ad-client="ca-pub-8326584585992829"
                            data-ad-slot="8454890613"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                      </div> -->

                      <div class="accordion accordion-secondary">
                        <div class="card mb-3">
                          <div class="card-body" v-if="distribution.status <= 2">
                            <p>
                              {{ $t('not_published_yet') }}
                            </p>
                          </div>
                          <div class="card-body" v-if="distribution.status > 2">
                            <p v-html="$t('description_music_stores')"></p>
                            <div class="mt-3">
                              <router-link
                                :to="`/tools/smartlinks/${smartlink._id}`"
                                class="btn btn-primary"
                                v-if="smartlink._id"
                              >{{ $t('manage_smartlink') }}</router-link>
                            </div>
                            <div class="mt-5" v-if="distribution.spotify_url">
                              <b>Spotify</b>
                              <br />
                              <a
                                :href="spotifyUrl"
                                target="_blank"
                              >{{ distribution.spotify_url }}</a>
                              <br>
                              <button class="btn btn-outline-primary btn-sm mt-2 mb-1" @click="copyText(spotifyUrl, 'Spotify link')">{{ $t('copy_link') }}<i class="fas fa-copy ml-2"></i></button>
                              <br>
                            </div>
                            <div class="mt-3" v-if="distribution.itunes_url">
                              <b>iTunes</b>
                              <br />
                              <a
                                :href="distribution.itunes_url"
                                target="_blank"
                              >{{ distribution.itunes_url }}</a>
                              <br>
                              <button class="btn btn-outline-primary btn-sm mt-2 mb-1" @click="copyText(distribution.itunes_url, 'iTunes link')">{{ $t('copy_link') }}<i class="fas fa-copy ml-2"></i></button>
                              <br>
                            </div>
                            <div class="mt-3" v-if="distribution.deezer_url">
                              <b>Deezer</b>
                              <br />
                              <a
                                :href="distribution.deezer_url"
                                target="_blank"
                              >{{ distribution.deezer_url }}</a>
                              <br>
                              <button class="btn btn-outline-primary btn-sm mt-2 mb-1" @click="copyText(distribution.deezer_url, 'Deezer link')">{{ $t('copy_link') }}<i class="fas fa-copy ml-2"></i></button>
                              <br>
                            </div>
                            <div class="mt-3" v-if="distribution.youtube_url">
                              <b>YouTube</b>
                              <br />
                              <a
                                :href="distribution.youtube_url"
                                target="_blank"
                              >{{ distribution.youtube_url }}</a>
                              <br>
                              <button class="btn btn-outline-primary btn-sm mt-2 mb-1" @click="copyText(distribution.youtube_url, 'YouTube link')">{{ $t('copy_link') }}<i class="fas fa-copy ml-2"></i></button>
                              <br>
                            </div>
                            <div class="mt-3" v-if="distribution.youtube_music_url">
                              <b>YouTube Music</b>
                              <br />
                              <a
                                :href="distribution.youtube_music_url"
                                target="_blank"
                              >{{ distribution.youtube_music_url }}</a>
                              <br>
                              <button class="btn btn-outline-primary btn-sm mt-2 mb-1" @click="copyText(distribution.youtube_music_url, 'YouTube Music link')">{{ $t('copy_link') }}<i class="fas fa-copy ml-2"></i></button>
                              <br>
                            </div>
                            <div class="mt-3" v-if="distribution.pandora_url">
                              <b>Pandora</b>
                              <br />
                              <a
                                :href="distribution.pandora_url"
                                target="_blank"
                              >{{ distribution.pandora_url }}</a>
                              <br>
                              <button class="btn btn-outline-primary btn-sm mt-2 mb-1" @click="copyText(distribution.pandora_url, 'Pandora link')">{{ $t('copy_link') }}<i class="fas fa-copy ml-2"></i></button>
                              <br>
                            </div>
                            <div class="mt-3" v-if="distribution.beatport_url">
                              <b>Beatport</b>
                              <br />
                              <a
                                :href="distribution.beatport_url"
                                target="_blank"
                              >{{ distribution.beatport_url }}</a>
                              <br>
                              <button class="btn btn-outline-primary btn-sm mt-2 mb-1" @click="copyText(distribution.beatport_url, 'Beatport link')">{{ $t('copy_link') }}<i class="fas fa-copy ml-2"></i></button>
                              <br>
                            </div>
                            <div class="mt-3" v-if="distribution.key">
                              <b>Indiefy Music</b>
                              <br />
                              <a
                                :href="`https://music.indiefy.net/releases/${distribution.key}`"
                                target="_blank"
                              >
                                https://music.indiefy.net/releases/{{distribution.key}}
                              </a>
                              <br>
                              <button class="btn btn-outline-primary btn-sm mt-2 mb-1" @click="copyText(spotifyUrl, 'Spotify link')">{{ $t('copy_link') }}<i class="fas fa-copy ml-2"></i></button>
                              <br>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" :class="{ 'active show': tab === 'publishedStores' }">
                      <div v-if="!user.subscription">
                        <div class="card card-dark bg-primary-gradient mb-4">
                          <div class="card-header pb-1">
                            <h3 class="mb-0" v-html="$t('maximize_royalties_title')">
                            </h3>
                          </div>
                          <div class="card-body py-2" v-html="$t('maximize_royalties_description')">
                          </div>
                          <div class="card-footer text-right">
                            <router-link to="/upgrade?from=distribution-stores" class="btn btn-gradient">
                              {{ $t('upgrade_now') }}
                            </router-link>
                          </div>
                        </div>
                      </div>

                      <h3>{{$t('music_published_stores')}}</h3>
                      <div class="table-responsive mt-3" v-if="distribution.delivered_dsps && distribution.delivered_dsps.length">
                        <table class="table table-stripped">
                          <thead>
                            <tr>
                              <th>Store</th>
                              <th class="text-right">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(dsp, index) in distribution.delivered_dsps" v-bind:key="`dsp_${index}`">
                              <td>
                                {{ dsp.name }}
                              </td>
                              <td class="text-right">
                                <span class="badge" :class="{ 'badge-success': dsp.state === 'DELIVERED', 'badge-warning': dsp.state === 'REJECTED' }">
                                  {{ dsp.state }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="accordion accordion-secondary" v-if="!distribution.delivered_dsps || !distribution.delivered_dsps.length">
                        <div class="card mb-3">
                          <div class="card-body">
                            <div class="container-img-store" v-for="(dsp, dspIndex) in distribution.dsps" v-bind:key="`dsp_${dspIndex}`" v-tooltip.top="{ content: getNameStores(dsp.dsp), delay: 0, class: 'tooltip-custom' }" v-show="getNameStores(dsp.dsp)">
                              <img v-if="dsp.dsp !== 1415672002" :src="`/static/img/stores-cms/${dsp.dsp}.png`" class="img-store" v-show="dsp.dsp !== 1415672002">
                            </div>
                          </div>
                        </div>
                        <div>
                      </div>
                      <div v-if="!user.subscription">
                        <h3>{{$t('missing_benefits_publishing_pro_stores')}}</h3>
                        <div class="card mb-3">
                          <div class="card-body">
                            <div class="container-img-store" v-for="(dsp, dspIndex) in this.distribution.prostores" v-bind:key="`dsp_${dspIndex}`" v-tooltip.top="{ content: getNameStores(dsp.dsp), delay: 0, class: 'tooltip-custom' }" v-show="getNameStores(dsp.dsp)">
                              <img v-if="dsp.dsp !== 1415672002" :src="`/static/img/stores-cms/${dsp.dsp}.png`" class="img-store" v-show="dsp.dsp !== 1415672002">
                            </div>
                          </div>
                        </div>
                        </div>
                      </div>

                    </div>
                    <div class="tab-pane" :class="{ 'active show': tab === 'banners' }">
                      <div class="accordion accordion-secondary">
                        <div class="card mb-3">
                          <div class="card-body">
                            <BannerGenerator :distribution="distribution"></BannerGenerator>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" :class="{ 'active show': tab === 'banners' }">
                      <div class="accordion accordion-secondary">
                        <div class="card mb-3">
                          <div class="card-body">
                            <BannerGenerator :distribution="distribution"></BannerGenerator>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" :class="{ 'active show': tab === 'comments' }">
                      <div class="accordion accordion-secondary">
                        <div class="card mb-3 p-3">
                          <div class="card-list">
                            <div v-if="!user.subscription" class="mb-4">
                              <div>
                                {{ $t('upgrade_to_unlock_features') }}
                              </div>
                            </div>
                            <div v-if="!user.subscription" class="blurred">
                              <div class="item-list" v-for="x in 4" v-bind:key="`dummy_${x}`">
                                <div class="avatar">
                                  <a :href="`https://indiefy.me/agnostic`" class="pull-left" target="_blank">
                                    <img src="https://assets.indiefy.net/profile-images/1567806225726.jpg" alt="..." class="avatar-img rounded-circle">
                                  </a>
                                </div>
                                <div class="info-user ml-3">
                                  <div class="username clearfix">
                                    <a :href="`https://indiefy.me/agnostic`" class="pull-left" target="_blank">
                                      Agnostic
                                    </a>
                                    <div class="pull-right pr-2 text-muted small">
                                      {{ moment().format('LLLL') }}
                                    </div>
                                  </div>
                                  <div class="status">
                                    <img width="16" :src="`/static/img/countries/MX.png`" class="mr-1"/> Mexico
                                  </div>
                                  <div class="mt-2">
                                    <i class="fa fa-quote-left text-muted mr-1"></i>
                                    Un Comentario Normal
                                    <i class="fa fa-quote-right ml-1 text-muted"></i>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-if="user.subscription">
                              <div class="item-list" v-for="(comment, commentIndex) in comments" v-bind:key="`comment_${commentIndex}`">
                                <div class="avatar">
                                  <a :href="`https://indiefy.me/${comment.author.key}`" class="pull-left" target="_blank">
                                    <img :src="comment.author.cover_image_small || comment.author.cover_image" alt="..." class="avatar-img rounded-circle">
                                  </a>
                                </div>
                                <div class="info-user ml-3">
                                  <div class="username clearfix">
                                    <a :href="`https://indiefy.me/${comment.author.key}`" class="pull-left" target="_blank">
                                      {{ comment.author.name }}
                                    </a>
                                    <div class="pull-right pr-2 text-muted small">
                                      {{ moment(comment.createdAt).format('MMM DD, HH:mm') }}
                                    </div>
                                  </div>
                                  <div class="status">
                                    <img width="16" :src="`/static/img/countries/${comment.country || 'default'}.png`" class="mr-1"/> {{ getCountryName(comment.country) }}
                                  </div>
                                  <div class="mt-2">
                                    <i class="fa fa-quote-left text-muted mr-1"></i>
                                    {{ $t(comment.strength) }} <span v-if="comment.areas_of_improvement">/ {{ $t(comment.areas_of_improvement) }}</span>
                                    <i class="fa fa-quote-right ml-1 text-muted"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer"></div>
          </div>
        </div>
      </div>
    </div>
    <div ref="metadataModal" class="modal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="mt-4 text-center">
            <h2 class="modal-title strong">{{ $t('modify_metadata') }}</h2>
            <hr class="mt-4">
          </div>
          <div class="modal-body">
            <div v-if="!isPro">
              <div class="mb-4">
                <h2 class="strong text-uppercase">{{ $t('only_for_pro') }}</h2>
                <div>{{ $t('metadada_only_for_pro_info') }}</div>
              </div>
              <div class="background-metadata p-2 text-white">
                <div class="mt-3">
                  <p class="h3 mt-1 mb-0"><span class="fw-light">Indiefy</span> <span class="strong">Pro</span></p>
                  <p class="small">{{ $t('metadata_sub_title') }}</p>
                </div>
                  <div class="float-left">
                    <p class="my-0"><i class="fas fa-check-circle mr-1"></i>{{ $t('live_metadata_changes')}}</p>
                    <p class="my-0"><i class="fas fa-check-circle mr-1"></i>{{ $t('takedowns_included')}}</p>
                    <p class="my-0"><i class="fas fa-check-circle mr-1"></i>{{ $t('unlimited_projects')}}</p>
                  </div>
                  <div class="float-right">
                    <p class="my-0"><i class="fas fa-check-circle mr-1"></i>{{ $t('metadata_unlimited_artists') }}</p>
                    <p class="my-0"><i class="fas fa-check-circle mr-1"></i>{{ $t('more_stores_and_protection') }}</p>
                    <p class="my-0"><i class="fas fa-check-circle mr-1"></i>{{ $t('special_discounts') }}</p>
                    <p class="my-0"><i class="fas fa-plus-circle mr-1"></i>{{ $t('and_more') }}</p>
                  </div>
                <router-link tag="button" class="btn btn-warning my-4 form-control strong text-uppercase" to="/upgrade">
                    {{ $t('upgrade_to_pro') }}
                </router-link>
              </div>
            </div>
            <div v-else>
              <div v-if="isPro" class="text-center">
                <p class="h1 mb-4 text-danger">
                  {{ metadataRemaining }} {{ $t('metadata_remaining') }}
                </p>
                <div>
                  <p class="my-4"> {{ $t('pro_metadata_remaining') }}</p>
                  <p v-html="$t('pro_metadata_contact_us')"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer w-100">
            <button type="button" class="btn btn-default w-50" data-dismiss="modal">{{ $t('close') }}</button>
            <button type="button" class="btn btn-primary w-50" @click="goToMetadataPage()" v-if="isPro && metadataRemaining">{{ $t('continue') }}</button>
          </div>
        </div>
      </div>
    </div>
    <div ref="takedownModal" class="modal modal-swal modal-h" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t('takedown_distribution') }}
          </div>
          <div class="modal-body">
            <div v-if="modalTakedownStep === 1">
              <p v-html="`<i class='fas fa-exclamation-triangle text-danger mr-1'></i>` + $t('takedown_warning_description')"></p>
              <div class="form-check pl-0 my-2 ml-4">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" value="" v-model="takedownAgree1" :disabled="currentDistro.takedown_object">
                  <span class="form-check-sign">{{ $t('takedown_yes_im_sure') }}</span>
                </label>
              </div>
              <p v-html="$t('takedown_proccess_info')"></p>
              <div class="form-check pl-0 my-2 ml-4">
                <label class="form-check-label">
                  <input class="form-check-input" type="checkbox" value="" v-model="takedownAgree2" :disabled="currentDistro.takedown_object">
                  <span class="form-check-sign">{{ $t('i_understand') }}</span>
                </label>
              </div>
              <div v-show="takedownAgree1 && takedownAgree2" class="animated fadeIn">
                <span>{{ $t('takedown_reason_text') }}<span class="text-danger ml-1 strong">*</span></span>
                <div class="mt-2">
                  <select class="form-control" style="height: 38px !important;" v-model="takedownReason" :disabled="currentDistro.takedown_object">
                    <option value="">{{ $t('takedown_reason_option_0') }}</option>
                    <option value="mistake">{{ $t('takedown_reason_option_1') }}</option>
                    <option value="release-copyright">{{ $t('takedown_reason_option_2') }}</option>
                    <option value="release-not-in-stores">{{ $t('takedown_reason_option_3') }}</option>
                    <option value="no-streams">{{ $t('takedown_reason_option_4') }}</option>
                    <option value="no-royalties">{{ $t('takedown_reason_option_5') }}</option>
                    <option value="other">{{ $t('other') }}</option>
                  </select>
                  <div v-if="takedownReason === 'other'">
                    <label class="my-2">{{ $t('reason') }}:<span class="text-danger ml-1 strong">*</span></label>
                    <textarea class="form-control" rows="4" maxlength="150" v-model="takedownOtherReason" :disabled="currentDistro.takedown_object"></textarea>
                    <small class="float-left text-danger">{{ $t('minimum') }} 20 {{ $t('characters')}}</small><small class="float-right text-danger">{{ $t('maximum') }} 150 {{ $t('characters')}}</small>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="modalTakedownStep === 2">
              <div class="text-center">
                <span class="text-success bold-600" v-if="takedownFree">
                  {{ $t('available') }}
                </span>
                <span class="text-danger bold-600" v-else>
                  {{ $t('not_available') }}
                </span>
              </div>
              <br>
              <span v-if="takedownFree" v-html="$t('takedown_free_payment_description')"></span>
              <span v-else v-html="$t('takedown_force_payment_description').replace('%s', takedownDaysLimit)"></span>
              <p v-if="!takedownFree" class="mt-3">
                <b><i class="fa fa-exclamation-triangle mr-1 text-warning"></i>{{ $t('warning') }}:</b> {{ $t('dmca_claim_warning') }}
              </p>
            </div>
          </div>
          <div class="modal-footer pt-5">
            <button type="button" class="btn btn-default btn-border no-border" data-dismiss="modal" @click="hideTakeDownModal()">{{ $t('cancel') }}</button>
            <button type="button" @click="modalTakedownStep = 2" class="btn btn-primary" v-if="modalTakedownStep === 1" :disabled="takedownDisableNextStep()">{{ $t('next') }}</button>
            <button type="button" @click="takedown(takedownFree)" class="btn btn-primary" v-if="modalTakedownStep === 2" :disabled="loadingTakedown">
              <i v-if="loadingTakedown" class="fa fa-spinner fa-spin"></i>
              <span v-if="takedownFree">{{ $t('request') }}</span>
              <span v-else>{{ $t('upgrade_to_pro') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div ref="takedownModalRestriction" class="modal modal-swal modal-h" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-center" role="document">
        <div class="modal-content">
          <div class="modal-header">
            {{ $t('takedown_request') }}
          </div>
          <div class="modal-body">
            <div class="text-center">
              <b class="danger">{{ $t('not_available') }}</b>
              <br>
              <br>
            </div>
            <div class="text-justify" v-html="$t('takedown_request_description')"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-border no-border" data-dismiss="modal">{{ $t('close') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import _ from 'underscore'
import Distributions from '../services/distributions'
import Configuration from '../services/configuration'
import Smartlinks from '../services/smartlinks'
import BannerGenerator from './BannerGenerator'
import STORES from '../data/distributionstores'
import countries from '../data/countries'

export default {
  name: 'DistributionEditor',
  data: function () {
    return {
      comments: [],
      tab: 'details',
      user: {},
      smartlink: {},
      isPro: false,
      formattedDate: '',
      releaseDate: null,
      contains: _.contains,
      distribution: {},
      myCroppa: {},
      selectedImage: '',
      moment: moment,
      metadataRemaining: 0,
      takedownReason: '',
      takedownOtherReason: '',
      lang: '',
      takedownAgree1: false,
      takedownAgree2: false,
      freeTakedownRemainingDays: 0,
      currentDistro: {
        release_date: null,
        status: null,
        approved_on: null,
        takedown_object: null
      },
      now: '',
      partnerize: false,
      camref: '',
      allStores: {
        1499657856: 'Instagram / Facebook',
        1809226414: 'TikTok',
        3405271817: 'YouTube Music',
        746109: 'Spotify',
        2100357: 'Deezer',
        99268: 'Amazon',
        3440259: 'TIDAL',
        7851192: 'Pandora',
        1209287754: 'Yandex Music',
        1210987244: 'UMA',
        89882: 'Beatport',
        1330598: 'Apple Music',
        103731: 'Napster',
        3441649: 'iHeartRadio',
        103725: 'iMusica / Claro ',
        247916: '7Digital',
        1988507361: 'Fizy',
        316911752: 'JioSaavn',
        78395129: 'Simfy Africa',
        1514168496: 'Boomplay',
        1207204780: 'TIM Music',
        3287973537: 'MonkingMe',
        464139: '24-7 Entertainment',
        9538495: 'Gracenote',
        20799134: 'Anghami',
        847103579: 'AWA',
        1963181516: 'Resso',
        1232212955: 'LINE Music',
        1234931270: 'Xiami',
        121452605: 'KkBox',
        1382854531: 'NetEase Cloud Music',
        1048705: 'Content ID (YouTube)',
        35299696: 'Soundcloud',
        4266325: 'Shazam',
        1674795424: 'Naver VIBE',
        1684139985: 'Mixcloud'
      },
      reopeningOptions: [],
      modalTakedownStep: 1,
      takedownDaysLimit: 180,
      loadingTakedown: false,
      takedownFree: null,
      defaultImage: '/static/img/img-placeholder.jpg',
      stripe: null,
      hideTakeDownButton: false
    }
  },
  computed: {
    spotifyUrl: function () {
      let pufRef = encodeURIComponent([
        't1', // origin distro detail
        this.distribution.title,
        this.distribution.artist.name,
        moment(this.distribution.release_date).format('YYYY/MM')
      ].join(', '))
      return this.partnerize ? `https://prf.hn/click/camref:${this.camref}/pubref:${pufRef.substring(0, 255)}/destination:${encodeURIComponent(this.distribution.spotify_url)}` : this.distribution.spotify_url
    }
  },
  methods: {
    getCountryName: function (userCountry) {
      let country = _.find(countries, item => item.code === userCountry)

      if (country) {
        return country.name
      }

      return 'N/A'
    },
    displayAds: function () {
      // if (!this.user.subscription) {
      //   setTimeout(() => {
      //     (window.adsbygoogle = window.adsbygoogle || []).push({})
      //   }, 2000)
      // }
    },
    openFormInNewTab () {
      window.open('https://forms.gle/q52ynbs68DdrZAGE8', '_blank')
    },
    cancelTakedown: async function (distributionId) {
      let resultDistributions = await Distributions.cancelTakedown(distributionId)

      if (resultDistributions.data && resultDistributions.data.success) {
        this.$notify({ message: this.$t('cancel_takedown_request') }, 'success', 'fa-check')
      } else {
        if (resultDistributions) {
          this.$notify({ message: resultDistributions.data.error }, 'warning', 'fa-exclamation')
        }
      }
    },
    getStores: function () {
      if (!this.distribution._id) {
        return
      }

      Distributions.getStores(this.distribution._id).then(response => {
        _.extend(this.distribution, response.data)

        if (this.distribution._id) {
          Smartlinks.getByRelease(this.distribution._id).then(response => {
            this.smartlink = response.data
          })

          setTimeout(() => {
            this.$forceUpdate()
          }, 500)
        }
      }).catch(() => {
        Smartlinks.getSmartlinkByKey(this.distribution.key).then(() => {
          setTimeout(() => {
            this.getStores()
          }, 5000)
        })
      })
    },
    showWarningDataChange: function () {
      let html = document.createElement('div')
      html.innerHTML = '<i class="fas fa-exclamation-triangle text-warning"></i><br>' +
      '<b>' + this.$t('metadata_warning_the_requirements') + '</b> ' + this.$t('metadata_warning_the_requirements_body') + '<br><br> '
      window.swal({
        title: this.$t('request_metadata_changes'),
        content: html,
        closeOnClickOutside: false,
        closeOnConfirm: true,
        buttons: {
          confirm: {
            text: this.$t('i_understand'),
            className: 'btn btn-primary'
          }
        }
      })
    },
    scrollToLinks: function () {
      setTimeout(() => {
        if (this.$refs.linksTab) {
          window.$('html, body').animate({
            scrollTop: window.$(this.$refs.linksTab).offset().top
          }, 1000)
        }
      }, 500)
    },
    takedown: function (isFree) {
      if (this.validateTakedownReason()) {
        this.loadingTakedown = true
        let dataToSend = {
          takedown_reason: this.takedownReason,
          takedown_reason_other: this.takedownOtherReason
        }

        if (isFree || this.user.subscription) {
          Distributions.setTakedown(this.currentDistro._id, dataToSend).then(response => {
            this.loadingTakedown = false
            window.$(this.$refs.takedownModal).modal('hide')
            this.$notify({ message: this.$t('takedown_sent') }, 'success', 'fa-check')
            setTimeout(() => {
              window.location.href = `/distributions/`
            }, 1500)
          })
        } else {
          this.$router.push(`/upgrade?from=takedown`)
        }
      }
    },
    showMetadataModal: function () {
      let dateValidate = new Date()
      if (dateValidate) {
        let html = document.createElement('div')
        html.innerHTML = '<i class="fas fa-exclamation-triangle text-warning pb-4 pt-3"></i><br>' + '<div class="pr-4 pl-4 pb-3">' + this.$t('due_maintenance') + '</div>'
        window.swal({
          title: this.$t('under_maintenance'),
          content: html,
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons: {
            confirm: {
              text: this.$t('i_understand'),
              className: 'btn btn-primary'
            }
          }
        })
      } else {
        let html = document.createElement('div')
        html.innerHTML = '<br><span style="text-align: center;display: block;color: #5714ff;font-weight: bold;font-size: 16px;">' + (this.distribution.modify_metadata || 0) + ((this.lang === 'es') ? ' de' : ' of') + ' 5</span><br><br>' + ((this.lang === 'es') ? '<b>Acerca de:</b> Eres elegible para <b>5 modificaciones cada 30 días</b> en tu cuenta PRO. Edita tu versión enviada y publicada; los cambios pueden tardar hasta 7 días en aparecer en las tiendas. ' : '<b>About:</b> You are eligible to <b>5 modifications every 30 days</b> on your PRO account. Edit your sent and published release, changes may take up to 7 days to show up on stores. ') + '<br><br>' +
        `<div>` +
          ((this.lang === 'es') ? 'Si necesitas cambiar metadatos que no figuran en el formulario, ponte en contacto con support@indiefy.net para obtener ayuda adicional.' : 'If you need to change metadata that is not listed in the form please contact support@indiefy.net for additional assistance.') +
        `</div>`
        window.swal({
          title: this.lang === 'es' ? 'Modificar lanzamiento' : 'Modify release',
          content: html,
          className: 'custom-modify-metadata',
          closeOnEsc: false,
          closeOnClickOutside: false,
          buttons: {
            cancel: {
              text: this.$t('cancel'),
              visible: true,
              className: 'btn btn-default'
            },
            confirm: {
              text: this.$t('continue'),
              className: 'btn btn-primary'
            }
          }
        }).then(confirm => {
          if (confirm) {
            this.goToMetadataPage()
          }
        })
      }
    },
    showTakedownModal: function (item) {
      Configuration.now().then(response => {
        this.now = response.data.now_iso
        this.currentDistro = item
        if (this.currentDistro.status === 3) {
          this.takedownDaysLimit = this.isPro ? 0 : 180
          this.takedownFree = moment(this.now).diff(moment(this.currentDistro.release_date), 'day') >= this.takedownDaysLimit
          if (this.currentDistro.takedown_object) {
            this.takedownAgree1 = true
            this.takedownAgree2 = true
            this.takedownReason = this.currentDistro.takedown_object.takedown_reason
            this.takedownOtherReason = this.currentDistro.takedown_object.takedown_reason_other
          }
          window.$(this.$refs.takedownModal).modal('show')
        }
      })
    },
    hideTakeDownModal: function () {
      this.takedownReason = ''
      this.takedownOtherReason = ''
      this.takedownAgree1 = false
      this.takedownAgree2 = false
      this.freeTakedownRemainingDays = 0
      this.currentDistro = {
        release_date: null,
        status: null,
        approved_on: null,
        takedown_object: null
      }
      this.modalTakedownStep = 1
      this.takedownDaysLimit = 180
      this.takedownFree = null
    },
    removeRelease: function () {
      window.swal({
        title: this.$t('are_you_sure'),
        text: this.$t('want_to_remove_release') + '\n\n' + this.$t('takedown_proccess_info').replace('<b>', '').replace('</b>', ''),
        className: 'icon-modal',
        icon: 'warning',
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: this.$t('cancel'),
            visible: true,
            className: 'btn btn-default'
          },
          confirm: {
            text: this.$t('confirm'),
            className: 'btn btn-success'
          }
        }
      }).then(confirm => {
        if (confirm) {
          Distributions.remove(this.distribution._id).then(response => {
            this.$notify({ message: this.$t('takedown_requested') }, 'success', 'fa-check')
            this.$router.push(`/distributions`)
          })
        }
      })
    },
    upgradeToPro: function () {
      this.$router.push(`/upgrade?from=releasedetails`)
    },
    getStatus: function () {
      let item = this.distribution

      if (item.status === 0 && !item.reopening_reason) {
        return this.$t('unsent')
      } else if (item.status === 0 && item.reopening_reason) {
        return this.$t('reopened')
      } else if (item.status === 1) {
        return this.$t('in_review')
      } else if (item.status === 2) {
        return this.$t('in_process')
      } else if (item.status === 3) {
        return this.$t('published')
      } else if (item.status === 4) {
        return this.$t('rejected')
      } else if (item.status === 5) {
        return this.$t('takedown_requested')
      } else if (item.status === 6) {
        return this.$t('unpublished')
      }
    },
    hasReopeningReason: function () {
      return (this.distribution.status === 0 && this.reopeningOptions.includes(this.distribution.reopening_reason))
    },
    goToMetadataPage: function () {
      this.$router.push(`/distributions/${this.distribution._id}/metadata`)
    },
    validateTakedownReason: function () {
      let response = false
      if (!this.takedownDisableNextStep()) {
        response = true
      }
      return response
    },
    emptyOtherReason: function () {
      return this.takedownReason === 'other' && this.takedownOtherReason.length < 20
    },
    freeTakedown: function () {
      return (moment().diff(this.releaseDate, 'days') >= 30)
    },
    buyTakedown: function () {
      return (moment().diff(this.releaseDate, 'days') < 30)
    },
    takedownDisableNextStep: function () {
      return (!this.takedownAgree1 || !this.takedownAgree2 || !this.takedownReason || this.emptyOtherReason())
    },
    copyText: function (txt, title) {
      if (typeof txt !== 'undefined') {
        let aux = document.createElement('input')
        aux.setAttribute('value', txt)
        document.body.appendChild(aux)
        aux.select()
        document.execCommand('copy')
        document.body.removeChild(aux)
        this.$notify({ message: this.$t('something_copied').replace('<br>', title) }, 'success', 'fa-check')
      }
    },
    getNameStores: function (dsp) {
      return this.allStores[dsp]
    },
    viewMetadataRequest: function () {
      this.$notify({ message: this.$t('metadata_changes_already_sent') }, 'success', 'fa-check')
    },
    showExtraFeaturesModal: function () {
      return this.$router.push('/upgrade?from=metadata_change')
    }
  },
  created: function () {
    this.user = this.$user
    this.lang = this.$i18n.locale
    this.stripe = window.Stripe('pk_live_Fy0LR9SOyRoSrq4Byoj3mQtS00GjNUCMRm')
    this.tab = this.$route.meta.tab || 'details'

    Configuration.get({fields: ['reopen_reasons_fields']}).then(response => {
      this.reopeningOptions = _.map(response.data.reopen_reasons_fields, (elem, key) => key)
    })

    this.isPro = !!this.$user.subscription

    if (this.$route.params.id) {
      Distributions.get(this.$route.params.id).then(response => {
        if (!this.user.subscription) {
          // 3405271817: 'YouTube Music', 1048705: 'Content ID (YouTube)', 746109: 'Spotify'&  2100357: 'Deezer'
          const targetIds = [2100357, 746109, 1048705, 3405271817]
          const filteredArray = response.data.dsps.filter(item => targetIds.includes(item.dsp))
          response.data.dsps = filteredArray
        }
        this.distribution = response.data
        this.distribution.dsps = this.distribution.dsps || []
        _.extend(this.distribution, STORES)

        _.each(this.distribution.songs, (song, index) => {
          if (song.featuring) {
            if (typeof song.featuring === 'string') {
              song.featuring = song.featuring.split(',')
              _.each(song.featuring, (item, index) => {
                let itemnew = item.trim()
                song.featuring[index] = {}
                song.featuring[index].name = itemnew
              })
            }
          }
        })

        this.releaseDate = response.data.release_date
        this.formattedDate = moment.utc(this.distribution.release_date).format('LL')

        Distributions.getMetadataLimit(this.$route.params.id).then(response => {
          this.metadataRemaining = response.data.available

          if (this.metadataRemaining <= 0) {
            this.metadataRemaining = 0
          }
        })

        if (this.hasReopeningReason()) {
          if (!this.distribution.reopen_in_progress) {
            return this.$router.push(`/distributions/${this.$route.params.id}/reopening-details`)
          }
        }

        if (this.distribution.status === 3) {
          this.freeTakedownRemainingDays = 30 - moment().diff(this.releaseDate, 'days')
          this.getStores()
        }

        if (this.tab === 'links') {
          this.scrollToLinks()
        }

        Configuration.now().then(response => {
          if ((moment(response.data.now_iso).diff(moment(this.releaseDate), 'days')) < 180) {
            this.hideTakeDownButton = true
          } else {
            this.hideTakeDownButton = false
          }
        })

        Distributions.getComments(this.distribution._id).then(response => {
          this.comments = response.data
        })

        this.displayAds()
        this.$forceUpdate()
      })
    }
  },
  watch: {
    $route: function (to, from) {
      this.tab = this.$route.meta.tab || 'details'

      if (this.tab === 'links') {
        this.scrollToLinks()
      }
    }
  },
  mounted: async function () {
    let config = await Configuration.get({fields: ['partnerize', 'camref']})
    this.partnerize = config.data.partnerize
    this.camref = config.data.camref

    this.$forceUpdate()
  },
  components: {
    BannerGenerator
  }
}
</script>
<style lang="scss" scoped>
.item-list {
  margin-bottom: 10px;
}

#distribution-image {
  width: 200px;
  height: 200px;
  border-radius: 3px;
}
.background-pro-guitar {
  background-image: url('/static/img/landing/pro/pro_background_guitar.jpg');
  background-size: cover;
  background-position: right;
}
.background-metadata {
  background-image: url('/static/img/landing/pro/metadata_background.jpg');
  background-size: cover;
  background-position: center;
}
.details {
  .btn-outline-primary {
    color: #5714ff;
    border-color: #5714ff;
    &:hover {
      background-color: #5714ff;
      border-color: #5714ff;
      color: #fff;
    }
  }
}
.cover-img {
  width: 70%;
}
.container-img-store {
  display: inline-block;
  width: 120px;
  margin-bottom: 25px;

  .img-store {
    height: 100px;
    padding: 5px;
  }
}
.danger {
  color: red;
}

.text-warning {
  color: #FFAB00;
}

.btn-promo {
  position: relative;

  span.new {
    position: absolute;

    top: -6px;
    right: -8px;
  }
}

.blurred {
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
  background-color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributionDetails.vue